module.exports = __webpack_public_path__ + "static/media/INV-0303 - Administrative Penalty Order - Destination Estates Ltd.c93b2d5e.pdf";